import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import enUS from "./locales/en_US";
import ptBR from "./locales/pt_BR";

// Define available languages
export const languages = {
	en_US: { nativeName: "English", flag: "🇺🇸" },
	pt_BR: { nativeName: "Português", flag: "🇧🇷" },
};

export type LanguageKey = keyof typeof languages;

// Initialize i18next
i18next.use(initReactI18next).init({
	resources: {
		en_US: {
			translation: enUS,
		},
		pt_BR: {
			translation: ptBR,
		},
	},
	lng: "pt_BR", // Default language
	fallbackLng: "pt_BR",
	interpolation: {
		escapeValue: false, // React already escapes values
	},
});

export default i18next;
